// role-utils.ts
const ROLE_ALIASES: Record<string, string> = {
  // canonical -> aliases that should map to it
  PM: 'PROJECT MANAGER|PM|PROJECT-MANAGER',
  AM: 'ACCOUNT MANAGER|AM|ACCOUNT-MANAGER',
  DMS: 'DMS',
  SEO: 'SEO',
  QA: 'QA|QUALITY ASSURANCE|QUALITY-ASSURANCE',
  BD: 'BD|BUSINESS DEVELOPMENT|BUSINESS-DEVELOPMENT',
  MIA: 'MIA|INTEGRATION|DEV|DEVELOPER', // you already map Integration -> MIA elsewhere
}

export function canonRole(raw?: string) {
  const s = (raw || '').trim().toUpperCase().replace(/\s+/g, ' ')
  if (!s) return ''
  for (const [canon, pattern] of Object.entries(ROLE_ALIASES)) {
    const rx = new RegExp(`^(?:${pattern})$`, 'i')
    if (rx.test(s)) return canon
  }
  return s // fallback: use cleaned string
}

export function rolesEqual(a?: string, b?: string) {
  return canonRole(a) === canonRole(b)
}
export const canon = (s?: string) => (s ?? '').trim().toUpperCase().replace(/\s+/g, ' ')
export const alias = (r: string) => {
  if (r === 'PROJECT MANAGER') return 'PM'
  if (r === 'ACCOUNT MANAGER') return 'AM'
  if (r === 'QUALITY ASSURANCE') return 'QA'
  if (r === 'INTEGRATION') return 'MIA'
  if (r === 'SEO') return 'SEO'
  return r
}
